import { useState } from "react";
import { Search } from "lucide-react";
import ProjectCard from "../components/modules/projects/ProjectCard";
import projectsData from "../data/projectsData";

const filters = ["All", "In Production", "Inspection", "Awaiting Approval", "Review", "Completed"];

export default function MyProjects() {
  const [query, setQuery] = useState("");
  const [activeFilter, setActiveFilter] = useState("All");

  const filtered = projectsData.filter((p) => {
    const matchesFilter = activeFilter === "All" || p.status === activeFilter;
    const matchesQuery =
      p.title.toLowerCase().includes(query.toLowerCase()) ||
      p.id.toLowerCase().includes(query.toLowerCase());
    return matchesFilter && matchesQuery;
  });

  return (
    <div>
      <h1 className="text-3xl font-extrabold text-gray-900">Projects</h1>
      <p className="text-gray-600 mt-1 mb-6">
        All your prototype builds, past and in progress.
      </p>

      {/* Search + filters */}
      <div className="bg-white border border-gray-100 rounded-2xl p-4 mb-6">
        <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 mb-4">
          <Search className="w-4 h-4 text-gray-400" />
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search by project name or ID..."
            className="w-full bg-transparent text-sm focus:outline-none"
          />
        </div>

        <div className="flex flex-wrap gap-2">
          {filters.map((f) => {
            const isActive = activeFilter === f;
            return (
              <button
                key={f}
                type="button"
                onClick={() => setActiveFilter(f)}
                className={`text-sm font-medium px-4 py-1.5 rounded-full border transition ${
                  isActive
                    ? "bg-indigo-600 border-indigo-600 text-white"
                    : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
                }`}
              >
                {f}
              </button>
            );
          })}
        </div>
      </div>

      {/* Project list */}
      {filtered.length > 0 ? (
        <div className="space-y-5">
          {filtered.map((p) => (
            <ProjectCard key={p.id} project={p} />
          ))}
        </div>
      ) : (
        <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
          No projects match your search.
        </div>
      )}
    </div>
  );
}